import React from "react";
import classNames from "classnames";
import "./mobile-bottom-nav.scss";

export interface MobileBottomNavItem {
  readonly id: string;
  readonly label: string;
  readonly icon: React.ReactNode;
  readonly badge?: number | null;
  readonly order?: number;
}

export interface MobileBottomNavProps {
  readonly items: MobileBottomNavItem[];
  readonly activeTab?: string;
  readonly onTabChange: (tab: string) => void;
  /**
   * ADO-541066 safe-area-inset fix, scoped behind the ADO-521159 loan-centric
   * nav flag per that story's implementation-stays-under-the-flag directive.
   * Legacy (flag-off) callers keep the original fixed 6.4rem sizing.
   */
  readonly safeAreaInsetEnabled?: boolean;
}

const MobileBottomNav: React.FC<MobileBottomNavProps> = ({
  items,
  activeTab,
  onTabChange,
  safeAreaInsetEnabled = false,
}) => {
  const sortedItems = [...items].sort((a, b) => (a.order ?? 0) - (b.order ?? 0));

  return (
    <nav
      className={classNames("mobile-bottom-nav", { "mobile-bottom-nav--safe-area-inset": safeAreaInsetEnabled })}
      aria-label="Bottom navigation"
      data-testid="mobile-bottom-nav"
    >
      <div className="mobile-bottom-nav__buttons">
        {sortedItems.map(({ id, label, icon, badge }) => (
          <button
            key={id}
            type="button"
            className={classNames({ active: activeTab === id })}
            onClick={() => onTabChange(id)}
            aria-selected={activeTab === id}
            role="tab"
          >
            <span className="mobile-bottom-nav__icon-container">
              {icon}
              {badge != null && badge > 0 && (
                <span className="nav-badge label-xsmall-regular">{badge}</span>
              )}
            </span>
            <span className="label-small-regular">{label}</span>
          </button>
        ))}
      </div>
    </nav>
  );
};

export default MobileBottomNav;
